import './App.css';
function Work(){
    return(
        <>
        <div>

        </div>
        </>
    )
}
export default Work